import { render, staticRenderFns } from "./PatentTranslateList.vue?vue&type=template&id=65e9263c&"
import script from "./PatentTranslateList.vue?vue&type=script&lang=js&"
export * from "./PatentTranslateList.vue?vue&type=script&lang=js&"
import style0 from "./PatentTranslateList.vue?vue&type=style&index=0&id=65e9263c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports